/**
 * TanStack Query hooks for `event-match-quality-emq-improvement-via-server-sid`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	eventMatchQualityEmqImprovementViaServerSidQueryKeys,
	type CreateEventMatchQualityEmqImprovementViaServerSidBody,
	type ListEventMatchQualityEmqImprovementViaServerSidResponse,
	type EventMatchQualityEmqImprovementViaServerSidRow,
} from "./api";

export function useEventMatchQualityEmqImprovementViaServerSidList(): UseQueryResult<ListEventMatchQualityEmqImprovementViaServerSidResponse, Error> {
	return useQuery({
		queryKey: eventMatchQualityEmqImprovementViaServerSidQueryKeys.list(),
		queryFn: list,
	});
}

export function useEventMatchQualityEmqImprovementViaServerSidCreate(): UseMutationResult<EventMatchQualityEmqImprovementViaServerSidRow, Error, CreateEventMatchQualityEmqImprovementViaServerSidBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: eventMatchQualityEmqImprovementViaServerSidQueryKeys.all });
		},
	});
}

export function useEventMatchQualityEmqImprovementViaServerSidDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: eventMatchQualityEmqImprovementViaServerSidQueryKeys.all });
		},
	});
}
